import {Component, Input, SimpleChanges} from '@angular/core';
import {FeedbackService} from "../../../services/feedback.service";
import {PopupService} from "../../../services/popup.service";
import {SearchService} from "../../../services/search.service";

@Component({
  selector: 'feedback-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

  @Input() report_id: string;
  @Input() element: string;

  public feedback: string = "";

  constructor(
    private feedbackService: FeedbackService,
    private popupService: PopupService,
    private searchService: SearchService,
  ){

  }

  ngOnChanges(changes: SimpleChanges) {
    // @ts-ignore
    if (changes.currentValue) {
      // @ts-ignore
      console.log('parentVariable has changed:', changes.currentValue);
      // @ts-ignore
      this.element = changes.currentValue;
      // React to the change as needed
    }
  }

  submitFeedback(){

    console.log({
      comment: this.feedback,
      search_id: this.report_id,
      feature_name: this.element,
    });

    this.feedbackService.comment({
      comment: this.feedback,
      search_id: this.report_id,
      feature_name: this.element,
    }).then(response => {
      if(response.data.status){
        this.popupService.notify("Your feedback has been shared with SalesOMMO!", "Thank you!", "success");
      } else {
        this.popupService.notify(response.data.message, "error", "error");
      }
      // @ts-ignore
      document.querySelectorAll("[data-modal-hide]").forEach(item => item.click());
    }).catch(error => {
      this.popupService.notify(error, "Error", "error");
    })
  }
}
